module.exports = __webpack_public_path__ + "static/media/triple-standard-img2.838860de.jpg";